import { createFileRoute, notFound } from "@tanstack/react-router";
import ServicePage, { serviceSlugRedirects } from "@/pages/ServicePage";
import { legacyRedirect } from "@/lib/legacy-redirect";
import { isServiceSlug, serviceHead } from "@/lib/route-seo";
import NotFound from "@/pages/NotFound";

// Legacy slug redirects ported from src/App.tsx
const LEGACY_SLUGS: Record<string, string> = {
  "warehouse-distribution": "/industries/warehouse-electrical",
  "data-centers": "/industries/data-center-electrical",
  "healthcare-facilities": "/industries/healthcare-facility-compliance",
  "hospitality-hotels": "/industries/hotel-electrical-contractor",
  "restaurants-retail": "/industries/restaurant-electrical",
  "automotive-plants": "/industries/automotive-plant-electrical",
  "education-schools": "/industries/school-electrical-contractor",
};

export const Route = createFileRoute("/industries/$slug")({
  beforeLoad: ({ params }) => {
    const target = LEGACY_SLUGS[params.slug];
    if (target) legacyRedirect(target);
    if (!isServiceSlug(params.slug) && !serviceSlugRedirects[params.slug]) throw notFound();
  },
  component: () => <ServicePage basePath="/industries" baseLabel="Industries" />,
  notFoundComponent: () => <NotFound hubPath="/industries" hubLabel="Industries" />,
  head: ({ params }) => serviceHead("/industries", "Industries", params.slug),
});
